import i18n from '../../../../i18n';
import { formatNorthStarValueInline } from '../../lib/northStarFormat';
import { detectNorthStarAwaitingProceed } from '../../lib/northStarProceed';
import type { NorthStarDraft, NorthStarPayload } from '../../types';
import type { ThreadMessage } from './threadTypes';

export function draftFromPayload(p: NorthStarPayload): NorthStarDraft {
  return {
    label: p.label,
    description: p.description,
    spec: p.spec,
    baseline: p.baseline,
    plan: p.plan,
  };
}

/** Opening message of a North Star flow that edits the saved North Star. */
export function northStarSummaryMessage(p: NorthStarPayload): string {
  const t = (key: string, options?: Record<string, unknown>) =>
    i18n.t(`assistant:northStarSummary.${key}`, options);
  const components = p.componentBreakdown
    .map(c => t('component', { label: c.label, weight: c.weight }))
    .join('\n');
  const planLines = p.plan.items
    .slice(0, 3)
    .map(i => `${i.priority}. ${i.title}`)
    .join('\n');
  return [
    t('editing', { label: p.label }),
    p.description ? `\n${p.description}` : '',
    `\n\n${t('current', {
      value: formatNorthStarValueInline(p.currentValue, p.spec.unit),
      baseline: formatNorthStarValueInline(p.baseline.value, p.spec.unit),
    })}`,
    components ? `\n\n${t('components')}\n${components}` : '',
    planLines ? `\n\n${t('topActions')}\n${planLines}` : '',
    `\n\n${t('next')}`,
  ].join('');
}

export function resolveAwaitingProceed(
  answer: string,
  draft: NorthStarDraft | null,
  explicit?: boolean,
): boolean {
  if (explicit != null) {
    return explicit;
  }
  return detectNorthStarAwaitingProceed(answer, draft);
}

/** The newest draft the flow produced (the save bar shows it). */
export function latestNorthStarDraft(messages: ThreadMessage[]): NorthStarDraft | null {
  for (let i = messages.length - 1; i >= 0; i -= 1) {
    const m = messages[i];
    if (m.role === 'assistant' && m.northStarDraft) return m.northStarDraft;
  }
  return null;
}
